export default {
  header: {
    title: 'Promotiecode of cadeaukaart',
  },
  available_codes: {
    title_one: 'Beschikbare code ({{count}})',
    title_other: 'Beschikbare codes ({{count}})',
    min_threshold: 'Min. {{value}}',
    percentage_off: '{{discount}}% korting op deze bestelling',
    amount_off: '{{amount}} korting op deze bestelling',
  },
  content: {
    input: {
      placeholder: 'Voer een code in',
    },
    buttons: {
      done: 'Klaar',
      apply: 'Toepassen',
      applied: 'Toegepast ✓',
    },
  },
};
